export const HOTELS_ENDPOINT_KEY = 'hotels'
